import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const YouTubeFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M22.0609 6.91205C21.8199 6.00285 21.1076 5.28694 20.2043 5.04353C18.5673 4.60205 12 4.60205 12 4.60205C12 4.60205 5.43273 4.60205 3.79568 5.04353C2.89244 5.28694 2.18011 6.00285 1.93909 6.91205C1.5 8.56103 1.5 11.9998 1.5 11.9998C1.5 11.9998 1.5 15.4385 1.93909 17.0875C2.18011 17.9967 2.89244 18.7126 3.79568 18.956C5.43392 19.3975 12 19.3975 12 19.3975C12 19.3975 18.5673 19.3975 20.2043 18.956C21.1076 18.7126 21.8199 17.9967 22.0609 17.0875C22.5 15.4397 22.5 11.9998 22.5 11.9998C22.5 11.9998 22.5 8.56103 22.0609 6.91205ZM9.85227 15.1223V8.87722L15.3409 11.9998L9.85227 15.1223Z" />
    </SvgIcon>
  );
});
